import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Icon from 'Components/Icon'
import { useNavigate } from 'react-router-dom'
import VisitsPaths from 'Application/Visits/Constants/VisitsPaths'
import BottomSheet from 'Components/BottomSheet'
import { removeVisit, setVisit } from 'Application/Visits/Actions/TempVisits'
import NetStatus from 'Components/NetStatus'
import { clearNewVisit, saveVisit } from 'Application/Visits/Actions/reducer'
import { useAppDispatch, useAppSelector } from 'Store/selectors'
import { useSettings } from 'Contexts/SettingsContext'
import Consts from 'Utils/Consts'

interface IProps {
  activeStep: number
}

const NewVisitHeader = (props: IProps) => {
  const [discardModalVisible, setDiscardModalVisible] = useState(false)

  const [t] = useTranslation()
  const navigate = useNavigate()
  const newVisit = useAppSelector(store => store.visits.newVisit)
  const dispatch = useAppDispatch()
  const { settings } = useSettings()

  const isCustomerDeliberately =
    (newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD' &&
      newVisit.customerDeliberately.vehicleCard &&
      newVisit.customerDeliberately.vehicleCardBack) ||
    (newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC' &&
      newVisit.customerDeliberately.vehicleDoc) ||
    (newVisit.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC' &&
      newVisit.customerDeliberately.vehicleCompanyDoc)

  const isDraftRequiredCount = !!newVisit.draftVisitId && isCustomerDeliberately
  const storeFileType = settings?.REACT_APP_STORE_FILE_TYPE ?? Consts.env.REACT_APP_STORE_FILE_TYPE

  const GetTitle = (): string => {
    switch (props.activeStep) {
      case 0:
        return t('DELIBERATELY')
      case 1:
        return t('VEHICLE_VISITING_POINTS')
      case 2:
        return t('VEHICLE_VISITING_POINTS_VIEW')
      case 3:
        return t('VEHICLE_ACCESSORIES')
      case 4:
        return `مشخصات ${t('VEHICLE')}`
      case 5:
        return t('CUSTOMER_INFO')
      case 6:
        return t('OPTIONS')
      case 7:
        return t('NOT_HEALTHY_AUTO_PARTS')
      case 8:
        return t('VALUE')
      // case 7:
      //return t("VEHICLE_VISITING_POINTS")
      case 9:
        return t('DESCRIPTION')
      default:
        return t('DELIBERATELY')
    }
  }

  return (
    <>
      <div className="flex justify-between items-center h-16 px-6 shrink-0">
        <div className="flex justify-between items-center gap-2">
          <div
            onClick={() => {
              if (props.activeStep === 0 && !isDraftRequiredCount) {
                dispatch(clearNewVisit(storeFileType))
                return navigate(VisitsPaths.VisitsMain)
              }

              if (props.activeStep <= 2) {
                if (newVisit.lastChangeTime) {
                  setDiscardModalVisible(true)
                } else {
                  navigate(VisitsPaths.VisitsMain)
                }
                return
              }

              setDiscardModalVisible(true)
            }}
          >
            <Icon name="arrow-right" className="w-6 h-6 text-gray-700" />
          </div>
          <div className="text-lg font-bold pl-2 relative">
            {GetTitle()}
            <span
              className={`w-[10px] h-[10px] rounded-full absolute left-0 top-0 ${newVisit.storeFileType == 'POD_SPACE' ? 'bg-success' : 'bg-error'}`}
            />
          </div>
        </div>
        <div className="flex justify-between items-center">
          <NetStatus />
          <div
            className="label label-outline-default"
            style={{ marginRight: '8px' }}
          >{`${props.activeStep + 1} از 10`}</div>
        </div>
      </div>
      <BottomSheet
        title=""
        visible={discardModalVisible}
        onCancel={() => setDiscardModalVisible(false)}
      >
        <div
          style={{
            width: 50,
            height: 6,
            backgroundColor: '#ccc',
            borderRadius: 3,
            position: 'absolute',
            top: 8,
            left: '50%',
            transform: 'translateX(-50%)',
          }}
        />

        <div className="overflow-auto px-6 pb-6">
          <div className="text-black text-sm mb-4">{t('DISCARD_MESSAGE')}</div>
        </div>

        {/* دکمه‌ها با ترتیب صحیح */}
        <div className="cta flex flex-col gap-4">
          {/* دکمه ذخیره موقت */}
          <button
            type="button"
            className="btn btn-primary btn-lg flex items-center justify-center w-full"
            disabled={false}
            onClick={() => {
              dispatch(saveVisit())
              setDiscardModalVisible(false)
              navigate(VisitsPaths.VisitsMain)
            }}
          >
            {t('TEMP_SAVE')}
          </button>

          <button
            type="button"
            className="btn btn-error btn-lg flex items-center justify-center w-full"
            disabled={false}
            onClick={() => {
              removeVisit(Number(newVisit.visitLocalId))
              setDiscardModalVisible(false)
              navigate(VisitsPaths.VisitsMain)
            }}
          >
            {t('DISCARD')}
          </button>
        </div>
      </BottomSheet>
    </>
  )
}

export default NewVisitHeader
